const path = '$calendar';

//
// ──────────────────────────────────────────────────── I ──────────
//   :::::: C O M M O N : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────
//

export const ADD_ACTION = `${path}/action/add`;
export const GET_ACTION = `${path}/action/get`;
export type ACTION_TYPE = 'FOLDERS' | 'ROOMS' | 'USERS' | 'EVENTS' | 'DAILYEVENTS' | 'SEARCHEVENTS';

export const SIDEBAR_CURRENT = `${path}/sidebar/current`;
export const SIDEBAR_CONTEXT_STATE = `${path}/sidebar/context/state`;
export const COMMON_COLOR_ARRAY = ["rgb(255, 0, 0)", "rgb(255, 89, 0)", "rgb(179, 235, 28)", "rgb(58, 253, 2)", "rgb(0, 255, 210)", "rgb(0, 13, 255)", "rgb(5, 0, 193)", "rgb(164, 87, 234)", "rgb(159, 159, 162)", "rgb(255, 255, 255)", "rgb(242, 135, 132)", "rgb(241, 206, 133)", "rgb(230, 240, 134)", "rgb(153, 239, 135)", "rgb(135, 239, 226)", "rgb(136, 156, 238)", "rgb(185, 136, 238)", "rgb(238, 136, 220)", "rgb(179, 196, 193)", "rgb(238, 213, 187)", "rgb(227, 237, 188)", "rgb(190, 235, 213)", "rgb(133, 91, 28)", "rgb(64, 128, 128)", "rgb(139, 175, 16)", "rgb(188, 154, 192)"];

export const COMMON_WEEK_ARRAY = ['일','월','화','수','목','금','토'];
export const COMMON_COLOR_ARRAY_GET = function(index: number): string {
    return COMMON_COLOR_ARRAY[index % COMMON_COLOR_ARRAY.length];
}
export const COMMON_DATE_CURRENT = `${path}/common/datetime/current`;
export const COMMON_CHANGE_DATE = `${path}/common/datetime/change`;
export const COMMON_DATE_SELECT = `${path}/common/datetime/select`; 
export const COMMON_DATE_SELECT_TODAY = `${path}/common/datetime/select/today`; 
export const CALENDAR_MAININIT = `${path}/calendar/maininit`;

export const COMMON_DATE_MONTH_PREV = `${path}/common/datetime/month/prev`;
export const COMMON_DATE_MONTH_NEXT = `${path}/common/datetime/month/next`;
export const COMMON_DATE_SELECT_MONTH = `${path}/common/datetime/month/select`;
export const COMMON_DATE_SELECT_YEAR = `${path}/common/datetime/year/select`;

export const COMMON_DATE_WEEK_PREV = `${path}/common/datetime/week/prev`;
export const COMMON_DATE_WEEK_NEXT = `${path}/common/datetime/week/next`;

export const COMMON_DATE_DATE_PREV = `${path}/common/datetime/date/prev`;
export const COMMON_DATE_DATE_NEXT = `${path}/common/datetime/date/next`;

export const COMMON_CALENDAR_PREV = `${path}/common/calendar/prev`;
export const COMMON_CALENDAR_NEXT = `${path}/common/calendar/next`;

export const COMMON_ERROR_MESSAGE = `${path}/common/errormessage`;
export const COMMON_ERROR_CLEAR = `${path}/common/errormessage/clear`;

export const COMMON_REFRESH = `${path}/common/refresh`;

export const COMMON_ROOM_LOAD = `${path}/common/room/load`;
export const COMMON_ROOM_LIST = `${path}/common/room/list`;

// 현재 사용자가 누구인지 가져오기
export const COMMON_CURRNT_USER = `${path}/common/current/user`;
export const COMMON_TOGGLE_CONTENTMASK = `${path}/common/contentmask/toggle`;
export const COMMON_SHOW_CONTENTMASK = `${path}/common/contentmask/show`;

//
// ──────────────────────────────────────────────────────── I ──────────
//   :::::: F O L D E R : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────────
//

export const FOLDER_SELECT = `${path}/folder/select`;
export const FOLDER_LIST_TREE = `${path}/folder/list/tree`;
export const FOLDER_LOAD_TREE = `${path}/folder/load/tree`;
export const FOLDER_ADD = `${path}/folder/add`;
export const FOLDER_EDIT_NAME = `${path}/folder/edit/name`;
export const FOLDER_EDIT_COLOR = `${path}/folder/edit/color`;
export const FOLDER_DELETE = `${path}/folder/delete`;
export const FOLDER_ROOT = `${path}/folder/root`;

//
// ──────────────────────────────────────────────────────── I ──────────
//   :::::: C A L E N D A R : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────────
//
export const CALENDAR_TODAY_MODE = `${path}/calendar/today/mode`;
export const CALENDAR_CURRENT_RECURRING = `${path}/calendar/current/recurring`;
export const CALENDAR_NEXT = `${path}/calendar/next`;
export const CALENDAR_DATE_NEXT = `${path}/calendar/date/next`;
export const CURRENT_CALENDAR_ITEM = `${path}/calendar/current/item`;
export const CALENDAR_DATE_CURRENT = `${path}/calendar/date/current`;
export const CALENDAR_DATE_SELECT = `${path}/calendar/date/select`;

export const CALENDAR_DATETIME_CURRENT = `${path}/calendar/datetime/current`;
export const CALENDAR_DATETIME_SELECT = `${path}/calendar/datetime/select`;

export const CALENDAR_EVENT_SELECT_ID = `${path}/calendar/event/select/id`;

export const CALENDAR_EVENT_ADD = `${path}/calendar/event/add`;
export const CALENDAR_EVENT_EDIT = `${path}/calendar/event/edit`;
export const CALENDAR_EVENT_ACCEPT = `${path}/calendar/event/accept`;
export const CALENDAR_EVENT_DECLINE = `${path}/calendar/event/decline`;
export const CALENDAR_EVENT_CANCEL = `${path}/calendar/event/cancel`;
export const CALENDAR_EVENT_REMOVE = `${path}/calendar/event/remove`;

export const CALENDAR_EVENT_LOAD_LIST = `${path}/calendar/event/load/list`;

export const CALENDAR_DAILY_EVENT_LOAD_LIST = `${path}/calendar/daily/event/load/list`;
export const CALENDAR_DAILY_EVENT_LIST = `${path}/calendar/daily/event/list`;

export const CALENDAR_HIDE_SHOW = `${path}/calendar/show/hide`;

export const CALENDAR_VIEWMODE_CHANGE = `${path}/calendar/viewmode/change`;
export const CALENDAR_VIEWMODE = `${path}/calendar/viewmode`;

export const CALENDAR_MONTH_MATRIX_LOAD = `${path}/calendar/month/load`;
export const CALENDAR_MONTH_MATRIX_LIST = `${path}/calendar/month/list`;

export const CALENDAR_WEEK_MATRIX_LOAD = `${path}/calendar/week/load`;
export const CALENDAR_WEEK_MATRIX_LIST = `${path}/calendar/week/list`;

export const CALENDAR_DATE_MATRIX_LOAD = `${path}/calendar/date/load`;
export const CALENDAR_DATE_MATRIX_LIST = `${path}/calendar/date/list`;

export const CALENDAR_SEARCH_LOAD = `${path}/calendar/search/load`;
export const CALENDAR_SEARCH_LIST = `${path}/calendar/search/list`;
export const CALENDAR_SEARCH_OPTION = `${path}/calendar/search/option`;
export const CALENDAR_SEARCH_SHOW = `${path}/calendar/search/show`;
export const CALENDAR_RECURRING_SHOW = `${path}/calendar/recurring/show`;

export const CALENDAR_DOWNLOAD = `${path}/calendar/download`;

export const CALENDAR_SHARED_SET = `${path}/calendar/shared/set`;
export const CALENDAR_SHARED_SHOW = `${path}/calendar/shared/show`;

export const CALENDAR_FOLDER_NAME = `${path}/calendar/folder/name`;

export const CALENDAR_PRINT_LIST = `${path}/calendar/print/list`;

export const CALENDAR_RECURRING_LOAD = `${path}/calendar/recurring/edit`;

export const CALENDAR_CURRENT_APPOINTMENT = `${path}/calendar/current/appointment`;